module.exports = __webpack_public_path__ + "media/brands/lada-2977b4ba.png";